import type { ResultOf, VariablesOf } from 'gql.tada';
import { gql } from '@/utilities/gql';
import { makeGqlMutation } from '@/utilities/gqlQuery';
import { useMutationWithSnackbar } from '../useMutationWithSnackbar';
import { DRAFT_UPDATE_FRAGMENT } from '../draftUpdateFragment';

const MUTATION = gql(
  `
  mutation startNarrativeUpdate($input: StartNarrativeUpdateInput!) {
    startNarrativeUpdate(input: $input) {
      ...DraftUpdateFields
    }
  }
`,
  [DRAFT_UPDATE_FRAGMENT]
);

export type StartNarrativeUpdateInput = VariablesOf<typeof MUTATION>;
export type StartNarrativeUpdateResult = ResultOf<typeof MUTATION>;

const useStartNarrativeUpdate = makeGqlMutation(MUTATION);

type StartNarrativeUpdateWithSnackbarOptions = {
  errorMessage?: string;
  includeSuccessSnackbar?: boolean;
  successMessage?: string;
};

export const useStartNarrativeUpdateWithSnackbar = (
  options: StartNarrativeUpdateWithSnackbarOptions = {}
) => {
  const mutation = useStartNarrativeUpdate();
  return useMutationWithSnackbar(mutation, {
    errorMessage: options.errorMessage || 'Failed to start narrative update',
    includeSuccessSnackbar: options.includeSuccessSnackbar || false,
    successMessage:
      options.successMessage || 'Successfully started narrative update',
  });
};
